import React from 'react';
import { SlideLayout } from '../ui/SlideLayout';
import { LayoutIcon, MapPinIcon, NavigationIcon, MousePointerClickIcon, LinkIcon, AlertCircleIcon } from 'lucide-react';
interface BlockerCardProps {
  icon: any;
  title: string;
  description: string;
}
const BlockerCard: React.FC<BlockerCardProps> = ({
  icon: Icon,
  title,
  description
}) => <>
    <div className="glass-card p-4 sm:p-6 border-l-4 border-l-red-500" data-id="element-286">
      <div className="flex items-start gap-3 sm:gap-4" data-id="element-287">
        <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-lg bg-red-500/10 flex items-center justify-center shrink-0 mt-0.5" data-id="element-288">
          <Icon className="w-4 h-4 sm:w-5 sm:h-5 text-red-500" data-id="element-289" />
        </div>
        <div className="min-w-0" data-id="element-290">
          <h3 className="text-base sm:text-lg font-bold text-slate-900 mb-1 sm:mb-2" data-id="element-291">
            {title}
          </h3>
          <p className="text-xs sm:text-sm text-slate-600 leading-relaxed" data-id="element-292">
            {description}
          </p>
        </div>
      </div>
    </div>
  </>;
export function RevenueBlockers() {
  return <>
      <SlideLayout data-id="element-293">
        <div className="mb-6 sm:mb-10" data-id="element-294">
          <div className="w-12 h-1 bg-red-500 mb-4 sm:mb-6 rounded-full" data-id="element-295" />
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-slate-900 mb-2 sm:mb-4" data-id="element-296">
            Revenue Blockers Holding Back Growth
          </h2>
          <p className="text-sm sm:text-xl text-slate-500" data-id="element-297">
            Structural and strategic gaps preventing your website from
            converting visitors.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-6 mb-6 sm:mb-12" data-id="element-298">
          <BlockerCard icon={LayoutIcon} title="No Dedicated Service Pages" description="Missing targeted pages for mortgage solutions like refinancing, renewals, and first-time buyer programs." data-id="element-299" />
          <BlockerCard icon={MapPinIcon} title="No Location Pages" description="No geo-targeted landing pages for Kingston and surrounding areas where potential clients are searching." data-id="element-300" />
          <BlockerCard icon={NavigationIcon} title="Unclear Site Structure" description="Website navigation doesn't guide visitors toward key services or conversion points effectively." data-id="element-301" />
          <BlockerCard icon={MousePointerClickIcon} title="Weak Call-to-Actions" description="CTAs are inconsistent, unclear, or missing on key pages — reducing conversion rates significantly." data-id="element-302" />
          <BlockerCard icon={LinkIcon} title="Poor Internal Linking" description="Content isn't connected strategically, weakening SEO authority flow and user navigation paths." data-id="element-303" />
        </div>

        <div className="bg-gradient-to-r from-slate-50 to-white border border-gold-500/30 rounded-xl sm:rounded-2xl p-4 sm:p-8 relative overflow-hidden shadow-sm" data-id="element-304">
          <div className="absolute top-0 right-0 w-40 sm:w-64 h-40 sm:h-64 bg-gold-500/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4" data-id="element-305" />

          <h3 className="text-base sm:text-xl font-bold text-gold-600 mb-3 sm:mb-6 flex items-center gap-2" data-id="element-306">
            <AlertCircleIcon className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-307" />
            Business Impact
          </h3>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-2 sm:gap-y-4 gap-x-8" data-id="element-308">
            <div className="flex items-center gap-3" data-id="element-309">
              <div className="w-1.5 h-1.5 rounded-full bg-gold-500 shrink-0" data-id="element-310" />
              <span className="text-xs sm:text-base text-slate-700 font-medium" data-id="element-311">
                Missing high-intent mortgage search traffic
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-312">
              <div className="w-1.5 h-1.5 rounded-full bg-gold-500 shrink-0" data-id="element-313" />
              <span className="text-xs sm:text-base text-slate-700 font-medium" data-id="element-314">
                Losing local search visibility to competitors
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-315">
              <div className="w-1.5 h-1.5 rounded-full bg-gold-500 shrink-0" data-id="element-316" />
              <span className="text-xs sm:text-base text-slate-700 font-medium" data-id="element-317">
                Confusing user journey reduces conversions
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-318">
              <div className="w-1.5 h-1.5 rounded-full bg-gold-500 shrink-0" data-id="element-319" />
              <span className="text-xs sm:text-base text-slate-700 font-medium" data-id="element-320">
                Lower lead volume and missed revenue opportunities
              </span>
            </div>
          </div>
        </div>
      </SlideLayout>
    </>;
}